// extracted by mini-css-extract-plugin
export default {"banner":"InstallPage_banner__-0fXU"};